import { render, staticRenderFns } from "./CashguardDialog.vue?vue&type=template&id=13ed2d7e"
import script from "./CashguardDialog.vue?vue&type=script&lang=js"
export * from "./CashguardDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports